import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import globalMixins from './mixin/globals'
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";
import Slick from 'vue-slick';
import VueMeta from 'vue-meta';

Vue.mixin({
  created() {
    dayjs.extend(relativeTime);
    dayjs.locale("ko",{
      relativeTime: {
        future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            m: '1분',
            mm: '%d분',
            h: '1시간',
            hh: '%d시간',
            d: '1일',
            dd: '%d일',
            M: '1개월',
            MM: '%d개월',
            y: '1년',
            yy: '%d년',
      },});
    this.$dayjs = dayjs;
  }
})

Vue.use(globalMixins)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Slick)
Vue.use(VueMeta)

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
    console.error("Vue error:", err)
}
const pinia = createPinia()
Vue.use(pinia)

new Vue({
  router: router,
  render: h => h(App),
  pinia,
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
